import { css } from 'linaria';

export const productInfoServices = css`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const productInfoServiceWrapper = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-basis: content;
  padding: 12px;
  background-color: #d3f0f3;
  border-radius: var(--rounding-l);
`;

export const productInfoServiceTextWrapper = css`
  display: flex;
  align-items: center;
`;

export const productInfoServiceText = css`
  width: 218px;
  margin-right: 24px;
  margin-left: 16px;

  @media (--only-desktop) {
    width: 153px;
  }

  @media (--only-tablet) {
    width: 448px;
  }

  @media (--only-mobile) {
    width: auto;
  }
`;

export const productInfoServicePriceWrapper = css`
  padding: 10px 20px;
  background-color: var(--background-primary);
  border-radius: var(--rounding-l);

  @media (--only-mobile) {
    width: 100%;
    padding: 6px 12px;
  }
`;
